import { Media, mbSize } from '@foxrenderfarm/common/src/theme'
import styled from 'styled-components'

export const InputWrapper = styled.div<{
  $width: number
  $height: number
  $fontSize: number
  $mbWidth: number
  $mbHeight: number
  $mbFontSize: number
  $color: string
  $borderColor: string
  $borderFocusColor: string
  $borderRadius: string
  $placeholderColor: string
}>`
  display: flex;
  align-items: center;
  border: 1px solid ${({ $borderColor }) => $borderColor};
  transition: all 0.3s;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  font-size: ${({ $fontSize }) => `${$fontSize}px`};
  font-weight: 400;
  padding: 0 10px;
  border-radius: ${({ $borderRadius }) => $borderRadius};
  input {
    outline: none;
    border: 0px;
    flex: 1;
    padding: 0;
    color: ${({ $color }) => $color};
    font-family: MarkPro;
  }
  input::placeholder {
    font-weight: 400;
    color: ${({ $placeholderColor }) => $placeholderColor};
  }
  &:focus-within {
    border-color: ${({ $borderFocusColor }) => $borderFocusColor};
  }
  ${Media.lessThan(Media.small)} {
    width: ${({ $mbWidth }) => mbSize($mbWidth)};
    height: ${({ $mbHeight }) => mbSize($mbHeight)};
    font-size: ${({ $mbFontSize }) => mbSize($mbFontSize)};
    padding: 0 ${mbSize(15)};
  }
`

export const Suffix = styled.span`
  margin-left: 4px;
  color: #999999;
`
